<template>
  <div>
    <div v-if="showTitle">
      <span class="cs-title">真留学员信息</span>
    </div>
    <el-row v-if="showTitle">
      <el-col>&nbsp;</el-col>
    </el-row>
    <div v-if="!showError && !!this.saStudent.StudentId">
      <table v-if="mode === 'mini'">
        <tr>
          <td class="cs-label">
            <span>姓名:</span>
          </td>
          <td>
            <span>{{saStudent.StudentName}}</span>
          </td>
        </tr>
        <tr>
          <td class="cs-label">
            <span>手机号码:</span>
          </td>
          <td>
            <span>{{saStudent.Phone}}</span>
          </td>
        </tr>
        <tr>
          <td class="cs-label">
            <span>学校:</span>
          </td>
          <td>
            <span>{{saStudent.UniversityName}}</span>
          </td>
        </tr>
      </table>
      <table v-else-if="mode === 'simple'">
        <tr>
          <td class="cs-label">
            <span>姓名:</span>
          </td>
          <td>
            <span>{{saStudent.StudentName}}</span>
          </td>
        </tr>
        <tr>
          <td class="cs-label">
            <span>手机号码:</span>
          </td>
          <td>
            <span>{{saStudent.Phone}}</span>
             <el-button class="edit-button" v-if="enableEdit" type="text" size="medium" @click="onResetPas">重置密码</el-button>
          </td>
        </tr>
        <tr>
          <td class="cs-label">
            <span>学校:</span>
          </td>
          <td>
            <span>{{saStudent.UniversityName}}</span>
          </td>
        </tr>
        <tr>
          <td class="cs-label">
            <span>购买真留服务总额:</span>
          </td>
          <td>
            <span>{{saleAmountDiscountedText}}</span>
          </td>
        </tr>
        <tr>
          <td class="cs-label">
            <span>剩余真留服务额度:</span>
          </td>
          <td>
            <span>{{saleAmountAvailableText}}</span>
          </td>
        </tr>
        <tr v-if="showChannel">
          <td class="cs-label">
            <span>渠道:</span>
          </td>
          <td>
            <div v-if="!editChannelOptions.isEditing">
              <span>{{saStudent.ChannelId ? saStudent.ChannelName : "暂无"}}</span>
              <el-button class="edit-button" v-if="enableEdit" type="text" size="medium" @click="onEditChannelClick">编辑</el-button>
            </div>
            <div v-else>
              <el-select size="mini" clearable v-model="editChannelOptions.editValue" placeholder="请选择渠道">
                <el-option v-for="item in saChannelList" :key="item.Id" :label="item.Name" :value="item.Id" />
              </el-select>
              <el-button class="edit-button" v-if="enableEdit" type="text" size="medium" @click="onEditChannelSaveClick">保存</el-button>
              <el-button class="edit-button" type="text" size="medium" @click="onEditChannelCancelClick">取消</el-button>
            </div>
          </td>
        </tr>
      </table>
      <table v-else>
        <tr>
          <td class="cs-label">
            <span>姓名:</span>
          </td>
          <td>
            <span>{{saStudent.StudentName}}</span>
          </td>
          <td rowspan="4">
            <!-- <div style="overflow:hidden; height: calc(100%); border-left: 1px solid black; padding-left: 20px;">&nbsp;</div> -->
            <el-divider direction="vertical" />
          </td>
          <td class="cs-label">
            <span>购买真留服务总额:</span>
          </td>
          <td>
            <span>{{saleAmountDiscountedText}}</span>
          </td>
        </tr>
        <tr>
          <td class="cs-label">
            <span>手机号码:</span>
          </td>
          <td>
            <span>{{saStudent.Phone}}</span>
          </td>
          <td class="cs-label">
            <span>已消耗真留服务总额:</span>
          </td>
          <td>
            <span>{{saleAmountDeductionText}}</span>
          </td>
        </tr>
        <tr>
          <td class="cs-label">
            <span>学校:</span>
          </td>
          <td>
            <span>{{saStudent.UniversityName}}</span>
          </td>
          <td class="cs-label">
            <span>剩余真留服务额度:</span>
          </td>
          <td>
            <span>{{saleAmountAvailableText}}</span>
          </td>
        </tr>
        <tr>
          <td class="cs-label">报名日期:</td>
          <td>{{saStudent.CreatedDateText}}</td>
          <td class="cs-label">
            <span v-if="showChannel">渠道:</span>
          </td>
          <td>
            <div v-if="showChannel">
              <div v-if="!editChannelOptions.isEditing">
                <span>{{saStudent.ChannelId ? saStudent.ChannelName : "暂无"}}</span>
                <el-button class="edit-button" v-if="enableEdit" type="text" size="medium" @click="onEditChannelClick">编辑</el-button>
              </div>
              <div v-else>
                <el-select size="mini" clearable v-model="editChannelOptions.editValue" placeholder="请选择渠道">
                  <el-option v-for="item in saChannelList" :key="item.Id" :label="item.Name" :value="item.Id" />
                </el-select>
                <el-button class="edit-button" v-if="enableEdit" type="text" size="medium" @click="onEditChannelSaveClick">保存</el-button>
                <el-button class="edit-button" type="text" size="medium" @click="onEditChannelCancelClick">取消</el-button>
              </div>
            </div>
          </td>
        </tr>
      </table>
    </div>
    <div v-else>
      <el-row>
        <el-col>
          <span class="cs-color-frenchgrey" v-text="errorMessage"></span>
        </el-col>
      </el-row>
    </div>
    <el-dialog title="重置密码" :center="true" :close-on-click-modal="false" :visible.sync="resetPasswordDialogVisibe" top="10vh">
      <passwordEditor type="resetPassword" :studentId="dataIn.studentId" v-on:closeEditor="onCloseEditor"></passwordEditor>
    </el-dialog>
  </div>
</template>

<script>
import {
  getChannelList,
  getStudyAbroadStudent,
  saveStudyAbroadStudentChannel,
} from "@/service/studyAbroad.service";
import passwordEditor from "../passwordEditor";

const defaultSAStudent = {
  StudentId: 0,
  StudentName: null,
  Phone: null,
  SaleAmountDiscountedCAD: 0,
  SaleAmountDiscountedCNY: 0,
  SaleAmountAvailableCAD: 0,
  SaleAmountAvailableCNY: 0,
  WorkflowCurrencyList: [],
  ChannelId: null,
  ChannelName: null,
  ChannelCurrency: null,
};

export default {
  name: "studentInfo",
  props: {
    mode: {
      type: String,
      default: "normal",
      validator: (value) => ["normal", "simple", "mini"].contains(value),
    },
    showTitle: {
      type: Boolean,
      default: false,
    },
    showChannel: {
      type: Boolean,
      default: true
    },
    enableEdit: {
      type: Boolean,
      default: false,
    },
    dataIn: {
      studentId: {
        type: [Number, String],
        default: 0,
      },
      studentData: {
        type: Object,
        default: () => {
          return null;
        },
      },
    },
  },
  components: {
    passwordEditor
  },
  data() {
    return {
      resetPasswordDialogVisibe: false,
      showError: false,
      errorMessage: "未查询到该学生",
      saChannelList: [],
      saStudent: Object.clone(defaultSAStudent),
      editChannelOptions: {
        isEditing: false,
        editValue: "",
      },
    };
  },
  created() {
    this.$nextTick(async () => {
      await this.loadChannelListFromServer();
      this.reloadSAStudent();
    });
  },
  computed: {
    saleAmountDiscountedText() {
      if (this.saStudent.WorkflowCurrencyList.length === 0) {
        switch (this.saStudent.ChannelCurrency) {
          case this.GLOBAL.currencyType.CNY:
            return Object.toCurrency(
              this.saStudent.SaleAmountDiscountedCNY,
              this.saStudent.ChannelCurrency
            );
          case this.GLOBAL.currencyType.CAD:
            return Object.toCurrency(
              this.saStudent.SaleAmountDiscountedCAD,
              this.saStudent.ChannelCurrency
            );
          default:
            return String.empty;
        }
      }

      var value = String.empty;
      this.saStudent.WorkflowCurrencyList.forEach((currency) => {
        switch (currency) {
          case this.GLOBAL.currencyType.CNY:
            value += `${Object.toCurrency(
              this.saStudent.SaleAmountDiscountedCNY,
              currency
            )} | `;
            break;
          case this.GLOBAL.currencyType.CAD:
            value += `${Object.toCurrency(
              this.saStudent.SaleAmountDiscountedCAD,
              currency
            )} | `;
            break;
        }
      });

      return value.rTrim(" | ");
    },
    saleAmountDeductionText() {
      if (this.saStudent.WorkflowCurrencyList.length === 0) {
        switch (this.saStudent.ChannelCurrency) {
          case this.GLOBAL.currencyType.CNY:
            return Object.toCurrency(
              this.saStudent.SaleAmountDeductionCNY,
              this.saStudent.ChannelCurrency
            );
          case this.GLOBAL.currencyType.CAD:
            return Object.toCurrency(
              this.saStudent.SaleAmountDeductionCAD,
              this.saStudent.ChannelCurrency
            );
          default:
            return String.empty;
        }
      }

      var value = String.empty;
      this.saStudent.WorkflowCurrencyList.forEach((currency) => {
        switch (currency) {
          case this.GLOBAL.currencyType.CNY:
            value += `${Object.toCurrency(
              this.saStudent.SaleAmountDeductionCNY,
              currency
            )} | `;
            break;
          case this.GLOBAL.currencyType.CAD:
            value += `${Object.toCurrency(
              this.saStudent.SaleAmountDeductionCAD,
              currency
            )} | `;
            break;
        }
      });

      return value.rTrim(" | ");
    },
    saleAmountAvailableText() {
      if (this.saStudent.WorkflowCurrencyList.length === 0) {
        switch (this.saStudent.ChannelCurrency) {
          case this.GLOBAL.currencyType.CNY:
            return Object.toCurrency(
              this.saStudent.SaleAmountAvailableCNY,
              this.saStudent.ChannelCurrency
            );
          case this.GLOBAL.currencyType.CAD:
            return Object.toCurrency(
              this.saStudent.SaleAmountAvailableCAD,
              this.saStudent.ChannelCurrency
            );
          default:
            return String.empty;
        }
      }

      var value = String.empty;
      this.saStudent.WorkflowCurrencyList.forEach((currency) => {
        switch (currency) {
          case this.GLOBAL.currencyType.CNY:
            value += `${Object.toCurrency(
              this.saStudent.SaleAmountAvailableCNY,
              currency
            )} | `;
            break;
          case this.GLOBAL.currencyType.CAD:
            value += `${Object.toCurrency(
              this.saStudent.SaleAmountAvailableCAD,
              currency
            )} | `;
            break;
        }
      });

      return value.rTrim(" | ");
    },
  },
  methods: {
    async loadChannelListFromServer() {
      let result = await getChannelList();
      this.saChannelList = !!result && result.success ? result.data : [];
    },
    async loadSAStudentFromServer() {
      if (!this.dataIn.studentId) {
        this.showError = true;
        return;
      }

      let result = await getStudyAbroadStudent(this.dataIn.studentId);
      this.saStudent =
        !!result && result.success && !!result.data
          ? result.data
          : Object.clone(defaultSAStudent);
      this.showError = !this.saStudent.StudentId;
    },
    async saveSAStudentChannelToServer() {
      let result = await saveStudyAbroadStudentChannel(
        this.saStudent.StudentId,
        this.editChannelOptions.editValue
      );
      if (!result || !result.success || !result.data) {
        this.$message.error(`保存失败.${result.message || ""}`);
        return false;
      }

      let selectedChannel = this.saChannelList.find(
        (item) => item.Id === this.editChannelOptions.editValue
      );
      this.saStudent.ChannelId = !!selectedChannel
        ? selectedChannel.Id
        : this.editChannelOptions.editValue;
      this.saStudent.ChannelName = !!selectedChannel
        ? selectedChannel.Name
        : null;
      this.saStudent.ChannelCurrency = !!selectedChannel
        ? selectedChannel.Currency
        : null;

      this.$emit("change", {
        StudentId: this.saStudent.StudentId,
        FieldsValue: {
          ChannelId: this.saStudent.ChannelId,
          ChannelName: this.saStudent.ChannelName,
          ChannelCurrency: this.saStudent.ChannelCurrency,
        },
      });

      this.$message({
        message: "渠道修改成功.",
        type: "success",
      });

      return true;
    },
    reloadSAStudent() {
      if (!!this.dataIn.studentData && !!this.dataIn.studentData.StudentId) {
        this.saStudent = Object.clone(this.dataIn.studentData);
        this.showError = false;
        return;
      }

      this.loadSAStudentFromServer();
    },
    onEditChannelClick() {
      this.editChannelOptions.editValue = this.saStudent.ChannelId;
      this.editChannelOptions.isEditing = true;
    },
    onEditChannelSaveClick() {
      let channelName = null;
      const selectedChannel = this.saChannelList.find(
        (item) => item.Id === this.editChannelOptions.editValue
      );

      if(selectedChannel)
        channelName = selectedChannel.Name;

      this.$confirm(
        (channelName ? ("您确定要将该学生的渠道修改为: " + channelName + " ?") : "您确定将该学生的渠道改为不设置?"),
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(async () => {
          let result = await this.saveSAStudentChannelToServer();
          if (result) {
            this.$emit("channelChange");
            this.onEditChannelCancelClick();
          }
        })
        .catch(() => {});
    },
    onEditChannelCancelClick() {
      this.editChannelOptions.isEditing = false;
    },
    onResetPas(){
      this.resetPasswordDialogVisibe = true;
    },
    onCloseEditor(){
       this.resetPasswordDialogVisibe = false;
    },
  },
  watch: {
    dataIn(newValue) {
      this.reloadSAStudent();
    },
  },
};
</script>

<style lang="scss" scoped>
td {
  padding-right: 10px;
  line-height: 28px;
  height: 28px;
}

.cs-label {
  min-width: 75px;
}

.el-divider {
  &.el-divider--vertical {
    height: 100%;
    margin: 0 16px;
  }
}

.edit-button {
  padding: 0px;
  margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/studyAbroad/studentInfo.vue